/* eslint-disable no-param-reassign */
import produce from "immer";

import {
  GET_INTERNAL_REASON_FAILURE,
  GET_INTERNAL_REASON_REQUEST,
  GET_INTERNAL_REASON_SUCCESS
} from "src/actions/cancelReasonAction";

const initialState = {
  internalReason: [],
  customerReason: [],
  loading: false
};

const cancelReasonReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_INTERNAL_REASON_REQUEST: {
      return produce(state, (draft) => {
        draft.internalReason = [];
        draft.loading = true;
      });
    }

    case GET_INTERNAL_REASON_SUCCESS: {
      const {response} = action.payload;

      return produce(state, (draft) => {
        const reasonForTop = response.filter((reason) => {
          const name = reason?.names?.vi || "";
          return !!reason?.is_active && name.startsWith("T_");
        });
        const reasonForCustomer = response.filter((reason) => {
          const name = reason?.names?.vi || "";
          return !!reason?.is_active && name.startsWith("C_");
        });

        draft.internalReason = reasonForTop;
        draft.customerReason = reasonForCustomer;
        draft.loading = false;
      });
    }

    case GET_INTERNAL_REASON_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }

    default: {
      return state; // We return the default state here
    }
  }
};

export default cancelReasonReducer;
